import { INavigationCategory, INavigationLink } from "../interfaces/INavigation";

import { 
    Dashboard as DashboardIcon,
    Settings,
    Security,
    Fingerprint,
    People,
    Business,
    Dvr,
    Description,
    DryCleaning,
    BarChart,
    PieChart,
    Lan,
    HomeRepairService,
    AttachMoney,
    BeachAccess
} from '@mui/icons-material';
import Start from "../pages/Admin/Start";
import DashboardGovernance from "../pages/Admin/Governance/Dashboard";
import AccessProfile from "../pages/Admin/Administrative/AccessProfile";
import User from "../pages/Admin/Administrative/User";
import Enterprise from "../pages/Admin/Administrative/Enterprise";
import SystemSettings from "../pages/Admin/Administrative/SystemSettings";
import RoomOverview from "../pages/Admin/Governance/RoomOverview";
import GovernanceReports from "../pages/Admin/Governance/Reports";
import AnalyticalDashboard from "../pages/Admin/Analytics/AnalyticalDashboard";
import GovernanceItem from "../pages/Admin/Administrative/GovernanceItem";
import RoomBlocking from "../pages/Admin/Governance/RoomBlocking";
import { RoomStatusData, RoomStatusEnum } from "./Enums";
import ManagementDashboard from "../pages/Admin/Analytics/ManagementDashboard";
import Department from "../pages/Admin/Administrative/Department";
import DashboardService from "../pages/Admin/Service/Dashboard";
import ServiceOrders from "../pages/Admin/Service/ServiceOrders";
import ServiceReports from "../pages/Admin/Service/Reports";
import FinancialDashboard from "../pages/Admin/Analytics/FinancialDashboard";
import VacationCenterDashboard from "../pages/Admin/Analytics/VacationCenterDashboard";


const StartLink: INavigationLink = {
    alias: [],
    name: 'start',
    description: undefined,
    Icon: null,
    Component: Start,
    items: null
};

const Navigation: INavigationCategory[] = [
    
    // Governance
    {
        title: 'governanceModuleName',
        alias: ['Governance.Dashboard', 'Governance.RoomOverview', 'Governance.RoomBlocking', 'Governance.Reports'],
        items: [
            {
                alias: ['Governance.Dashboard'],
                name: 'dashboard',
                description: undefined,
                Icon: DashboardIcon,
                Component: DashboardGovernance,
                items: null
            }, {
                alias: ['Governance.RoomOverview'],
                name: 'roomOverview',
                description: undefined,
                Icon: Dvr,
                Component: RoomOverview,
                items: null
            }, {
                alias: ['Governance.RoomBlocking'],
                name: 'roomBlocking',
                description: undefined,
                Icon: RoomStatusData[RoomStatusEnum.RoomBlocking].Icon,
                Component: RoomBlocking,
                items: null
            }, {
                alias: ['Governance.Reports'],
                name: 'reports',
                description: undefined,
                Icon: Description,
                Component: GovernanceReports,
                items: null
            }
        ]
    },


    // Service
    {
        title: 'serviceModuleName',
        alias: ['Service.Dashboard', 'Service.ServiceOrders', 'Service.Reports'],
        items: [
            {
                alias: ['Service.Dashboard'],
                name: 'dashboard',
                description: undefined,
                Icon: DashboardIcon,
                Component: DashboardService,
                items: null
            }, {
                alias: ['Service.ServiceOrders'],
                name: 'serviceOrders',
                description: undefined,
                Icon: HomeRepairService,
                Component: ServiceOrders,
                items: null
            }, {
                alias: ['Service.Reports'],
                name: 'reports',
                description: undefined,
                Icon: Description,
                Component: ServiceReports,
                items: null
            }
        ]
    },


    // Analytics
    {
        title: 'analyticsModuleName',
        alias: ['Analytics.AnalyticalDashboard', 'Analytics.ManagementDashboard', 'Analytics.FinancialDashboard', 'Analytics.VacationCenterDashboard'],
        items: [
            {
                alias: ['Analytics.AnalyticalDashboard'],
                name: 'analyticalDashboard',
                description: undefined,
                Icon: PieChart,
                Component: AnalyticalDashboard,
                items: null
            }, {
                alias: ['Analytics.ManagementDashboard'],
                name: 'managementDashboard',
                description: undefined,
                Icon: BarChart,
                Component: ManagementDashboard,
                items: null
            }, {
                alias: ['Analytics.FinancialDashboard'],
                name: 'financialDashboard',
                description: undefined,
                Icon: AttachMoney,
                Component: FinancialDashboard,
                items: null
            }, {
                alias: ['Analytics.VacationCenterDashboard'],
                name: 'vacationCenterDashboard',
                description: undefined,
                Icon: BeachAccess,
                Component: VacationCenterDashboard,
                items: null
            }
        ]
    },


    // Administrative
    {
        title: 'administrativeModuleName',
        alias: [
            'Administrative.Enterprises', 
            'Administrative.AccessProfiles', 
            'Administrative.Users', 
            'Administrative.GovernanceItems',
            'Administrative.Departments', 
            'Administrative.Settings'
        ],
        items: [
            {
                name: 'accessControl',
                description: undefined,
                Icon: Security,
                Component: () => null,
                alias: ['Administrative.Enterprises', 'Administrative.AccessProfiles', 'Administrative.Users'],
                items: [
                    {
                        alias: ['Administrative.Enterprises'],
                        name: 'enterprises',
                        description: undefined,
                        Icon: Business,
                        Component: Enterprise,
                        items: null
                    }, {
                        alias: ['Administrative.AccessProfiles'],
                        name: 'accessProfiles',
                        description: undefined,
                        Icon: Fingerprint,
                        Component: AccessProfile,
                        items: null
                    }, {
                        alias: ['Administrative.Users'],
                        name: 'users',
                        description: undefined,
                        Icon: People,
                        Component: User,
                        items: null
                    }
                ]
            }, {
                alias: ['Administrative.GovernanceItems'],
                name: 'governanceItems',
                description: undefined,
                Icon: DryCleaning,
                Component: GovernanceItem,
                items: null
            }, {
                alias: ['Administrative.Departments'],
                name: 'departments',
                description: undefined,
                Icon: Lan,
                Component: Department,
                items: null
            }, {
                alias: ['Administrative.Settings'],
                name: 'settings',
                description: undefined,
                Icon: Settings,
                Component: SystemSettings,
                items: null
            }, 
        ]
    },
];



export {
    StartLink
}

export default Navigation;